import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ListRefreshButtonProps {
  readonly isRefreshing: boolean;
  readonly onRefresh: () => void;
  readonly disabled?: boolean;
  readonly className?: string;
  readonly ariaLabel?: string;
}

export const ListRefreshButton = ({
  isRefreshing,
  onRefresh,
  disabled = false,
  className,
  ariaLabel,
}: ListRefreshButtonProps) => {
  const { t } = useTranslation('common');

  return (
    <button
      type="button"
      onClick={onRefresh}
      disabled={disabled || isRefreshing}
      aria-label={ariaLabel ?? t('refresh')}
      className={className ?? 'flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'}
    >
      <RefreshCw size={14} className={isRefreshing ? 'animate-spin' : undefined} />
      {isRefreshing ? t('refreshing') : t('refresh')}
    </button>
  );
};
